import React, { Component } from 'react';
import { Row,Col} from 'react-bootstrap';
import 'src/css/Top.css';
import CircleButton from "src/component/Util/CircleButton.js"
import TripReport from "src/img/Trip Report Icon.png"
import MonthlyReport from "src/img/Monthly Report Icon.png"
import Ranking from "src/img/Ranking Icon.png"
import SafetyMap from 'src/img/Safety Map Icon.png';
import 'src/i18n';
import { withTranslation , Trans } from 'react-i18next';


class Top extends Component {
  
  render() {
    return (
      <div>
        <div className='short-div' />
        <Row>
          <Col  className="center" md={6} sm={6} xs={6}>
            <CircleButton href="/trip_report" images={TripReport}/>
            <p className='bold center text'>
              <Trans i18nKey="Top.TripReport">
                Trip<br/>Report
              </Trans>
            </p>
          </Col>
          <Col  className="center" md={6} sm={6} xs={6}>
            <CircleButton href="/monthly_report" images={MonthlyReport}/>
              <p className='bold center text'>
                <Trans i18nKey="Top.MonthlyReport">
                  Monthly<br/>Report
                </Trans>
              </p>
          </Col>
          <Col  className="center" md={6} sm={6} xs={6}>
            <CircleButton href="/safety_map" images={SafetyMap}/>
            <p className='bold center text'>
              <Trans i18nKey="Top.SafetyMap">
                Safety<br/>Map
              </Trans>
            </p>
          </Col>
          <Col  className="center" md={6} sm={6} xs={6}>
            <CircleButton href="/ranking" images={Ranking}/>
              <p className='bold center text'>
                <Trans i18nKey="Top.Ranking">
                  ranking
                </Trans>  
              </p>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(Top);


// WEBPACK FOOTER //
// ./src/component/Top/Top.js